/* Var-Referenzen auf die zentralen Farb-Tokens (theme/tokens.css).
   Für Stellen, die Farben als Wert brauchen (z. B. Charts, inline styles),
   statt hartkodierter Hex-Werte. */

export const colors = {
  gold: "var(--p2p-gold)",
  goldTag: "var(--p2p-gold-tag)",
  teal: "var(--p2p-teal)",
  protein: "var(--p2p-protein)",
  kcal: "var(--p2p-kcal)",
  text: "var(--p2p-text)",
  muted: "var(--p2p-muted)",
  border: "var(--p2p-border)",
  inactive: "var(--p2p-inactive-bg)",
} as const;
